import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var CFFHinting = /** @class */ (function (_super) {
    __extends(CFFHinting, _super);
    function CFFHinting() {
        return _super.call(this) || this;
    }
    CFFHinting.forceNativeConstructor = true;
    CFFHinting.forceNativeMethods = true;
    CFFHinting.NONE = 'none';
    CFFHinting.HORIZONTAL_STEM = 'horizontalStem';
    return CFFHinting;
}(ASObject));
export { CFFHinting };
